import { createFileRoute } from "@tanstack/react-router";
import { LabPage, labHead } from "@/components/lab-page";

export const Route = createFileRoute("/lab/afeto")({
  head: () => labHead(
    "/lab/afeto",
    "Afeto Catalisador",
    "Afeto Catalisador: instalação interativa em 3D de toque, água, luz e som, no projeto O que é a loucura? de Luiza Jesus do Prado.",
  ),
  component: AffectLab,
});

function AffectLab() {
  return <LabPage src="https://luizajprado.github.io/sirene/afeto/" title={{ pt: "Afeto Catalisador", en: "Catalysing Affect", es: "Afecto Catalizador" }} />;
}